import { sanitize, SanitizeMode } from "./Tools";
var OptionResolver = /** @class */ (function () {
    function OptionResolver() {
    }
    OptionResolver.resolve = function (element, options) {
        var _a;
        if (options === void 0) { options = {}; }
        var state = null;
        var attrState = element.dataset.state;
        if (attrState === "dark")
            state = false;
        if (attrState === "light")
            state = true;
        return {
            state: (_a = state !== null && state !== void 0 ? state : options.state) !== null && _a !== void 0 ? _a : this.DEFAULTS.state,
            root: sanitize(element.dataset.root || options.root || this.DEFAULTS.root, { mode: SanitizeMode.TEXT }),
            allowCookie: !!element.dataset.allowCookie || options.allowCookie || this.DEFAULTS.allowCookie,
            lightLabel: sanitize(element.dataset.lightLabel || options.lightLabel || this.DEFAULTS.lightLabel, { mode: SanitizeMode.HTML }),
            darkLabel: sanitize(element.dataset.darkLabel || options.darkLabel || this.DEFAULTS.darkLabel, { mode: SanitizeMode.HTML }),
            lightColorMode: sanitize(element.dataset.lightColorMode || options.lightColorMode || this.DEFAULTS.lightColorMode, { mode: SanitizeMode.TEXT }),
            darkColorMode: sanitize(element.dataset.darkColorMode || options.darkColorMode || this.DEFAULTS.darkColorMode, { mode: SanitizeMode.TEXT }),
            style: this.DEFAULTS.style,
        };
    };
    OptionResolver.DEFAULTS = {
        state: true,
        root: ":root",
        allowCookie: false,
        lightLabel: "Light",
        darkLabel: "Dark",
        lightColorMode: "light",
        darkColorMode: "dark",
        style: "outline-secondary",
    };
    return OptionResolver;
}());
export { OptionResolver };
